import { defaultWorkspaceName } from '../../aiem/defaults';
import { useWorkspaces } from '../../pages/Orchestrator/WorkspaceProvider';
import { roleBindingResourceCompile } from '../authz.functions';
import { useQueryMultiplePermissionsCurrentUser } from '../authz.hooks';

export type AuthzPermissionInput = { action: string; resource?: string };

/**
 * Hook to check multiple authz permissions for the current user.
 * Returns array of booleans (granted/denied) and a loading flag.
 * If resource is undefined, uses the active workspace resource.
 */
export const useAuthzPermissions = (
  permissions: AuthzPermissionInput[]
): { results: boolean[]; isLoading: boolean } => {
  const { ACTIVE_WORKSPACE_NAME } = useWorkspaces();
  const defaultResource = roleBindingResourceCompile(ACTIVE_WORKSPACE_NAME || defaultWorkspaceName);

  const reqs = permissions.map((p) => ({
    action: p.action,
    resource: p.resource ?? defaultResource,
  }));

  const queryResults = useQueryMultiplePermissionsCurrentUser(reqs);

  const results = queryResults.map((q) => Boolean(q.data?.allowed));
  const isLoading = queryResults.some((q) => q.isLoading);

  return { results, isLoading };
};
